import { FC, SVGProps } from 'react'

export const Relaxing: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M4.15692 8.10617C3.80128 7.89382 3.34083 8.00998 3.12848 8.36562C2.91613 8.72126 3.03229 9.18171 3.38793 9.39406L6.65593 11.3454C7.01157 11.5577 7.47201 11.4416 7.68437 11.0859C7.89672 10.7303 7.78056 10.2698 7.42492 10.0575L4.15692 8.10617ZM2.11959 10.3152C1.75912 10.1112 1.30149 10.238 1.09745 10.5985C0.893398 10.9589 1.0202 11.4166 1.38067 11.6206L8.94585 15.903C9.1118 15.9969 9.30729 16.0241 9.49257 15.9791L16.7333 14.2179H21.7503C22.1645 14.2179 22.5003 13.8821 22.5003 13.4679C22.5003 13.0537 22.1645 12.7179 21.7503 12.7179H16.6434C16.5837 12.7179 16.5242 12.725 16.4661 12.7392L9.42647 14.4514L2.11959 10.3152Z"
			fill="currentColor"
		/>
	</svg>
)
